export async function rawFetchWithToken(url: string | URL, options?: RequestInit) {
  const normalisedUrl = url instanceof URL ? url.toString() : url;

  return fetch(normalisedUrl, {
    headers: {
      Authorization: `Bearer ${JSON.parse(localStorage['kl.jwtToken'])}`,
      'Content-Type': 'application/json',
    },
    ...options,
  });
}
